var React = require('react');

function IcCopy (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5 1h-12c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-11 16h11V7h-11v14z","fill":"currentColor"}));
}

IcCopy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcCopy;

IcCopy.default = IcCopy;
